const colors = {
  banner_gradient: 'linear-gradient(180deg, #7C43E8 -0.2%, #ffffff 90%)',
  coumo_purple: '#7C43E8',
  coumo_lightpurple: '#EDE4FC',
  lightpurple: '#f8f4ff', // image box 연한 purple
  lightpurple_border: '#7d43e868',
  text: '#7D7788', // input border 등 연한 text
  text_darkgray: '#514D59', // 탭, input color 등 진한 text
  text_black: '#383D43', // 요금제, 회원가입 등 검정 text 모두
  btn_lightgray: '#E3E1E8', // 버튼 disable, 쿠폰 radio border 등
  white: '#FFFFFF',
  hover: '#F5F4F7', // post hover시 lightgray (그 외에 text보다 연한 gray)
  line: '#D2D2D4', // 선
  text_shadow: '#6C31DB', // 쿠폰 UI 서비스 등 그림자
  error: '#FF5454', // 쿠폰 UI 서비스 등 그림자
};

const fontSize = {
  xs: '10px',
  sm: '12px',
  base: '14px',
  md: '16px',
  lg: '18px',
  title: '20px',
  xl: '24px',
};

export const theme = {
  colors,
  fontSize,
};
